export default __webpack_public_path__ + "static/media/argocd.a14f2a45.svg";